import CardChart from '../Components/CardChart'
import {
  Box,
  Typography,
  Chip,
  Button,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Skeleton
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'

const StudentsGrowthOverview = ({ isLoading, students = [], statuses = [] }) => {
  const [filterStatus, setFilterStatus] = useState('all')
  const [data, setData] = useState(students)

  const onFilterStatus = (student) => {
    if (filterStatus === 'all') {
      return true
    }
    return student.status === filterStatus
  }

  useEffect(() => {
    const newData = students?.filter(onFilterStatus)
    setData(newData)
  }, [students, filterStatus])

  return (
    <CardChart title={'Students Growth Overview'} bgColor='#fff' px={0}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          flexWrap: 'wrap',
          px: 2.5,
          minWidth: { md: 260 },
          mb: 1
        }}
      >
        <Chip
          label={`
            All: ${students?.length || 0}`}
          onClick={() => setFilterStatus('all')}
          icon={<FontAwesomeIcon icon={'user'} />}
          disabled={isLoading}
          sx={{
            fontWeight: 600,
            fontSize: '0.75rem',
            borderRadius: '999px',
            border: filterStatus === 'all' ? '2px solid currentColor' : 'none'
          }}
        />
        {statuses.map((s) => (
          <Chip
            key={s.id}
            label={`${s.label}: ${s.count || 0}`}
            onClick={() => setFilterStatus(s.label)}
            icon={<FontAwesomeIcon icon={s.icon} style={{ color: s.color }} />}
            sx={{
              backgroundColor: s.bgColor,
              color: s.color,
              fontWeight: 600,
              fontSize: '0.75rem',
              borderRadius: '999px',
              border: filterStatus === s.label ? '2px solid currentColor' : 'none'
            }}
          />
        ))}
      </Box>

      <TableContainer sx={{ height: '35vh' }}>
        <Table>
          <TableBody>
            {isLoading ? (
              Array.from({ length: 5 }).map((_, i) => (
                <TableRow key={i}>
                  <TableCell
                    width={'220px'}
                    sx={{
                      px: 2.5
                    }}
                  >
                    <Typography color='textSecondary' className='capitalize flex gap-4'>
                      <Skeleton width={130} height={20} />
                      <Skeleton width={30} height={20} />
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant='body2' color='textPrimary'>
                      <Skeleton width={80} height={20} />
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant='body2' color='textPrimary'>
                      <Skeleton width={80} height={20} />
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant='body2' color='textPrimary'>
                      <Skeleton width={80} height={20} />
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant='body2' color='textPrimary'>
                      <Skeleton width={80} height={20} />
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant='body2' color='textPrimary'>
                      <Skeleton width={80} height={20} />
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      px: 2.5
                    }}
                  >
                    <Typography variant='body2' color='textPrimary'>
                      <Skeleton width={100} height={20} />
                    </Typography>
                  </TableCell>
                </TableRow>
              ))
            ) : data?.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={2}
                  sx={{
                    px: 2.5
                  }}
                >
                  <Typography variant='h6' color='textSecondary'>
                    {"You don't have any students yet"}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              data?.filter(onFilterStatus)?.map((student, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        flexWrap: 'wrap',
                        px: 2.5,
                        minWidth: { md: 260 }
                      }}
                    >
                      {/* <Box
                        sx={{
                          height: 25,
                          width: 25,
                          bgcolor: student.iconColor,
                          borderRadius: '100%',
                          display: 'flex',
                          alignItems: ' center',
                          justifyContent: 'center'
                        }}
                      >
                        <FontAwesomeIcon
                          icon={student.icon}
                          style={{ color: student.statusBg, fontSize: '14px' }}
                        />
                      </Box> */}
                      <Typography variant='subtitle1' fontWeight='700' sx={{ color: '#111827' }}>
                        {student.name}
                      </Typography>

                      <Chip
                        label={student.status}
                        size='small'
                        icon={
                          <FontAwesomeIcon
                            icon={student.icon}
                            style={{ color: student.statusColor, fontSize: 12 }}
                          />
                        }
                        sx={{
                          backgroundColor: student.statusBg,
                          border: '1px solid currentColor',
                          color: student.statusColor,
                          fontWeight: 600,
                          fontSize: '0.75rem',
                          borderRadius: '999px'
                        }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ textAlign: 'center', minWidth: 60 }}>
                      <Typography variant='caption' sx={{ color: '#6b7280', display: 'block' }}>
                        Assessed
                      </Typography>
                      <Typography variant='subtitle2' fontWeight='700' sx={{ color: '#111827' }}>
                        {student.assessed || 0}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ textAlign: 'center', minWidth: 60 }}>
                      <Typography variant='caption' sx={{ color: '#1270aa', display: 'block' }}>
                        Growing
                      </Typography>
                      <Typography variant='subtitle2' fontWeight='700' sx={{ color: '#1270aa' }}>
                        {student.growing || 0}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ textAlign: 'center', minWidth: 70 }}>
                      <Typography variant='caption' sx={{ color: '#fc7d0b', display: 'block' }}>
                        Steady
                      </Typography>
                      <Typography variant='subtitle2' fontWeight='700' sx={{ color: '#fc7d0b' }}>
                        {student.steady || 0}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ textAlign: 'center', minWidth: 66 }}>
                      <Typography variant='caption' sx={{ color: '#c85201', display: 'block' }}>
                        Needs Review
                      </Typography>
                      <Typography variant='subtitle2' fontWeight='700' sx={{ color: '#c85201' }}>
                        {student.needsReview || 0}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                      <Box sx={{ textAlign: 'center', minWidth: 66 }}>
                        <Typography variant='caption' sx={{ color: '#000', display: 'block' }}>
                          Not Yet Assessed
                        </Typography>
                        <Typography variant='subtitle2' fontWeight='700' sx={{ color: '#000' }}>
                          {student.notYetAssessed || 0}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell
                    align='right'
                    sx={{
                      px: 2.5
                    }}
                  >
                    {/* <Button
                      variant='outlined'
                      size='small'
                      sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        whiteSpace: 'nowrap',
                        borderColor: '#d1d5db',
                        color: '#111827'
                      }}
                    >
                      View Student →
                    </Button> */}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </CardChart>
  )
}

export default StudentsGrowthOverview
